import { render, staticRenderFns } from "./site-dashboard.component.vue?vue&type=template&id=4bf6fdd4&scoped=true"
import script from "./site-dashboard.component.ts?vue&type=script&lang=ts&external"
export * from "./site-dashboard.component.ts?vue&type=script&lang=ts&external"
import style0 from "./site-dashboard.component.vue?vue&type=style&index=0&id=4bf6fdd4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf6fdd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf6fdd4')) {
      api.createRecord('4bf6fdd4', component.options)
    } else {
      api.reload('4bf6fdd4', component.options)
    }
    module.hot.accept("./site-dashboard.component.vue?vue&type=template&id=4bf6fdd4&scoped=true", function () {
      api.rerender('4bf6fdd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/site-dashboard/site-dashboard.component.vue"
export default component.exports